import { type FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query';
import { LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEYS } from '../project/defines';
import { getApiUrl, getCsrfToken, getTargetApiHeaders, getUniversFromUrl } from '../project/helpers';
import { getLocalStorageItem } from '../utils/helpers/localStorage';
import { getSessionStorageItemTtl, setSessionStorageItemTtl } from 'utils/helpers/sessionStorage';


const baseInnerQuery = async (apiName: string, allowUsePrivate: boolean, args: FetchArgs, api: any) => {
  const newArgs = { ...args };

  const session_code = getLocalStorageItem(LOCAL_STORAGE_KEYS.SessionCode);
  if (apiName !== 'translations' && apiName !== 'univers' && session_code && newArgs.url.indexOf('/id360/') === -1) {
    newArgs.params = { ...newArgs.params, session_code };
  }

  let url = `${getApiUrl(getUniversFromUrl())}/${apiName}`;

  let csrfToken = getCsrfToken();

  const headers: Record<string, string> = {
    'Content-Type': (newArgs.headers as any)?.['Content-Type'] || 'application/json',
  };

  //Object.assign(headers, getTargetApiHeaders());

  // Test multiple CSRF header variants
  if (csrfToken) {
    // Try most common header names
    headers['X-CSRF-Token'] = csrfToken;      // ASP.NET Core default
    headers['X-XSRF-TOKEN'] = csrfToken;      // Angular/axios convention
    headers['RequestVerificationToken'] = csrfToken; // ASP.NET MVC
    //console.log('✅ CSRF headers added (multi-format):', csrfToken);

    if (url.indexOf('/api/public') !== -1 && allowUsePrivate) {
      url = url.replace('/api/public', '/api')
    }
    if (newArgs.url.indexOf('/id360/') !== -1) {
      url = url.replace('/api/', '/')
    }
  } else {
    //console.log('⚠️ No CSRF token - request will probably fail if CSRF is required')
  }

  // fetchBaseQuery ignores the base headers when args.headers is set,
  // so merge them into the request headers (request-specific values win).
  newArgs.headers = {
    ...headers,
    ...(newArgs.headers as Record<string, string>),
    ...getTargetApiHeaders(),
  };


  return await fetchBaseQuery({
    baseUrl: url,
    //prepareHeaders: async (headers: Headers) =>{ },
    credentials: 'include',
    responseHandler: (response) => {
      if (response?.status === 204 || response?.statusText === "No Content") {
        return Promise.resolve(null);
      }
      if (response.status === 401) {
        return Promise.resolve({ status: 401, data: { error: 'Unauthorized' } });
      }
 
      return headers['Content-Type'] === 'application/json' ? response.json() : response.text();
    }, 
    headers
  })(newArgs, api, {});
};

const baseQuery = (apiName: string, allowUsePrivate: boolean = false) => async (args: FetchArgs, api: any) => {
  const response = await baseInnerQuery(apiName, allowUsePrivate, args, api);

  
  if (response.error?.status === 401 && args.url !== 'me') {
    //removeLocalStorageItem(LOCAL_STORAGE_KEYS.Auth)
    //dispatch(reloadIsLoggedInFromStorage())
    
    //globalThis.location.href = "/logout"
  }

  if (response.error && args.url !== 'me') {
    const { status } = response.error;
    
    // Only retry on transient errors
    const isTransientError = typeof status === 'number' && [401, 403, 408, 429, 503, 504].includes(status) ||
     typeof status === 'string' && ['FETCH_ERROR'].includes(status ?? 'NO_STATUS');
    if (!isTransientError) {
      return response; // Return immediately for permanent errors
    }

    const storedRetryStatus = getSessionStorageItemTtl(SESSION_STORAGE_KEYS.RetryStatus) ?? {};


    const retryCounter = parseInt(storedRetryStatus[args.url] ?? "0") + 1;
    storedRetryStatus[args.url] = retryCounter;
    if (retryCounter <= 3) {
      setSessionStorageItemTtl(SESSION_STORAGE_KEYS.RetryStatus, storedRetryStatus, 30);
      if (retryCounter === 3) { 
        // Max retries reached: stop reloading and show the message once.
        setSessionStorageItemTtl(SESSION_STORAGE_KEYS.RetryMessage, "true", 30);
      }
      location.reload();
    } 
``
    // const storedRetryUrl = getSessionStorageItemTtl(SESSION_STORAGE_KEYS.RetryUrl);
    // const retryCounter = parseInt(getSessionStorageItemTtl(SESSION_STORAGE_KEYS.RetryCounter) ?? "0");
    
    // // Reset counter if URL changed
    // const isNewRequest = !storedRetryUrl || storedRetryUrl !== args.url;
    // const newCounter = isNewRequest ? 1 : retryCounter + 1;

    // if (newCounter < 3) {
    //   setSessionStorageItemTtl(SESSION_STORAGE_KEYS.RetryUrl, args.url, 30);
    //   setSessionStorageItemTtl(SESSION_STORAGE_KEYS.RetryCounter, newCounter, 30);
    //   location.reload();
    // } else if (newCounter === 3) {
    //   // Max retries reached: stop reloading and show the message once.
    //   setSessionStorageItemTtl(SESSION_STORAGE_KEYS.RetryMessage, "true", 30);
    // }
  }
  return response;
};

export default baseQuery;

